exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".card-base{margin:0 6px;min-width:180px;height:164px;border-radius:10px;background-color:#fff;border:1px solid #dddfe2}.card-base.active{border:1px solid #0072c9}.card-base.success{border:1px solid #86c82d}.card-base.error{border:1px solid #c8175e}.card-base.mobile{min-width:0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/dist/cjs.js!./client/app/food-benefit.module/components/userCardList/userCardRow/homeCard/cardBase/cardBase.scss
// module id = 1601
// module chunks = 0